import { useEffect } from 'react'

/**
 * Tema daisyUI da aplicação — **único**, com as cores da marca Mediar.
 *
 * Antes o tema variava por segmento da empresa (HEALTH → `atendimento`, demais →
 * `atendimento-default`). Agora a marca é padronizada: um só tema para todos.
 * Os dois nomes ainda existem no `index.css` com as MESMAS cores (retrocompat
 * dos `data-theme="atendimento"` espalhados), mas resolvem no mesmo visual.
 *
 * Continua aplicando o tema no `<html>` — não é cosmético: sem `data-theme`, o
 * daisyUI gera `:root:not([data-theme])` com o tema escuro, que vence o
 * `:where(:root)` e vaza o `--color-base-100` escuro em dois lugares: no fundo de
 * página enquanto há `.modal-open`, e em tudo que vai para `document.body` via
 * `createPortal` (modais), fora da `div` tematizada dos layouts.
 */
const APP_THEME = 'atendimento'

export function useTheme(): string {
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', APP_THEME)
    }, [])

    return APP_THEME
}
